import gql from 'graphql-tag';
import { memberGQLFields } from '../network/index.js';
export const postReactionParticipantsGQLQuery = (fields) => gql `
  query PostReactionParticipants(
    $after: String
    $before: String
    $limit: Int!
    $offset: Int
    $postId: ID!
    $reaction: ID!
    $reverse: Boolean
  ) {
    postReactionParticipants(
      after: $after
      before: $before
      limit: $limit
      offset: $offset
      postId: $postId
      reaction: $reaction
      reverse: $reverse
    ) {
      totalCount
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        cursor
        node {
          participant {
            ${memberGQLFields(fields)}
          }
        }
      }
      nodes {
        participant {
          ${memberGQLFields(fields)}
        }
      }
    }
  }
`;
//# sourceMappingURL=reaction.gql.js.map